import { defineMessages } from "react-intl";

const messages = defineMessages({
    close: {
        id: "general.close",
    }
});

export default messages;
